import { IconName } from "@blueprintjs/core";

import { IconCircle } from "@/components/pieces/IconCircle";

const GRADE_MAP = {
  NotRelevant: {
    icon: "small-minus" as IconName,
    color: "#9E9E9E",
    backgroundColor: "#F6F6F6",
  },
  Bad: {
    icon: "small-cross" as IconName,
    color: "#991B1B",
    backgroundColor: "#FEE2E2",
  },
  Mid: {
    icon: "segmented-control" as IconName,
    color: "#8E301A",
    backgroundColor: "#FFEAD1",
  },
  Good: {
    icon: "tick" as IconName,
    color: "#0D8050",
    backgroundColor: "#D3F2E5",
  },
};

interface GradeIconProps {
  grade?: "NotRelevant" | "Bad" | "Mid" | "Good";
  size?: number;
  iconSize?: number;
}

export function GradeIcon({
  grade = "NotRelevant",
  size = 24,
  iconSize = 14,
}: GradeIconProps) {
  return (
    <IconCircle
      size={size}
      icon={GRADE_MAP[grade].icon}
      backgroundColor={GRADE_MAP[grade]?.backgroundColor || "#F6F6F6"}
      color={GRADE_MAP[grade]?.color || "#9E9E9E"}
      iconSize={iconSize}
    />
  );
}
